import { CircularProgress, Stack, useTheme, Typography } from "@mui/material";
import { useLanguage } from "src/context/LanguageProvider";
import { formatNumber } from "src/utils/formatting";
import EmptySetIcon from "src/assets/icons/empty-set.svg?react";
import { ScoreSourceChip } from "src/components/Score/ScoreSourceChip";
import { type ScoreSourceMeta } from "src/api/client-api/olapScores/olapScoresSchema";

type ScoreToggleButtonProps = {
    label: string;
    value?: number;
    unit?: string;
    isRefetching?: boolean;
    precision?: number;
    contributors?: ScoreSourceMeta[];
};

export const ScoreToggleButton = (props: ScoreToggleButtonProps) => {
    const { label, value, unit, isRefetching = false, precision = 3, contributors } = props;

    const { currentLanguage } = useLanguage();
    const theme = useTheme();

    return (
        <Stack direction="row" alignItems="center" gap="12px">
            <Typography variant="body-medium">{label}</Typography>
            <Stack direction="row" alignItems="center" gap="6px">
                {isRefetching ?
                    <CircularProgress size="18px" />
                : value !== undefined ?
                    <Typography variant="huge-bold">
                        {formatNumber(value, currentLanguage, {
                            minimumFractionDigits: precision,
                            maximumFractionDigits: precision,
                        })}
                    </Typography>
                :   <EmptySetIcon width="20px" height="20px" />}
                {unit && (
                    <Typography
                        variant="caption"
                        sx={{
                            color: theme.custom.grey[1400],
                            lineHeight: "normal",
                        }}
                    >
                        {unit}
                    </Typography>
                )}
                {value !== undefined && contributors && contributors.length > 0 && (
                    <ScoreSourceChip contributors={contributors} compact />
                )}
            </Stack>
        </Stack>
    );
};
